import React, { useMemo } from "react";
import Link from "../../lib/link/Link";
import styles from "./wordpress.module.scss";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pathSegment: string;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  pathSegment,
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          className={`page-item ${i === currentPage ? "disabled" : ""}`}
          key={i}
        >
          <Link
            className="page-link"
            href={`${pathSegment}${i - 1 < 1 ? "" : `?page=${i}`}`}
          >
            {i}
          </Link>
        </li>
      );
    }

    return pageNumbers;
  };

  if (totalPages <= 1) return null;

  const previousPage = useMemo(() => {
    if (currentPage === 1) return pathSegment;
    const previousPage = currentPage - 1;
    return pathSegment + (previousPage === 1 ? "" : `?page=${previousPage}`);
  }, [currentPage, pathSegment]);

  const nextPage = useMemo(() => {
    if (currentPage === totalPages) return pathSegment + `?page=${currentPage}`;
    return pathSegment + `?page=${currentPage + 1}`;
  }, [currentPage, pathSegment, totalPages]);

  const hasPreviousPage = currentPage > 1;

  const hasNextPage = currentPage < totalPages;

  return (
    <nav aria-label="Blog Pagination" className={styles["pagination"]}>
      <ul className="pagination justify-content-center">
        <li className={`page-item ${hasPreviousPage ? "" : "disabled"}`}>
          <Link className="page-link" href={previousPage}>
            Previous
          </Link>
        </li>
        {renderPageNumbers()}
        <li className={`page-item ${hasNextPage ? "" : "disabled"}`}>
          <Link className="page-link" href={nextPage}>
            Next
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
